/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum UserItemAliases {
  AUTOCOMPLETE_ESTABLISHMENT = 'autocomplete-establishment',
  AUTOCOMPLETE_LANGUAGE = 'autocomplete-language',
  AUTOCOMPLETE_LOCALE = 'autocomplete-locale',
  FETCH_ESTABLISHMENT = 'fetch-establishment',
  FIELD_CURRENT_PASSWORD = 'field-current-password',
  FIELD_ESTABLISHMENT = 'field-establishment',
  FIELD_LANGUAGE = 'field-language',
  FIELD_LOCALE = 'field-locale',
  FIELD_NEW_PASSWORD = 'field-new-password',
  FIELD_NEW_PASSWORD_CONFIRMATION = 'field-new-password-confirmation',
  FORM_CHANGE_PASSWORD = 'form-change-password',
  FORM_SETTINGS = 'form-settings',
  FORM_USER = 'form-user',
  INPUT_CURRENT_PASSWORD = 'input-current-password',
  INPUT_NEW_PASSWORD = 'input-new-password',
  INPUT_NEW_PASSWORD_CONFIRMATION = 'input-new-password-confirmation',
  LAYOUT_USER_ITEM = 'layout-user-item',
  MAPPER_0 = 'mapper-0',
  MAPPER_LANGUAGE = 'mapper-language',
  MAPPER_LOCALE = 'mapper-locale',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_USER_ITEM = 'panel-user-item',
  PHOTO_UPLOADER_AVATAR = 'photo-uploader-avatar',
  TAB_CONTROL_0 = 'tab-control-0',
  TAB_WITH_CONTENT_0 = 'tab-with-content-0',
  TAB_WITH_CONTENT_1 = 'tab-with-content-1',
  TAB_WITH_CONTENT_CHANGE_PASSWORD = 'tab-with-content-change-password',
  TEXT_0 = 'text-0',
  TEXT_LANGUAGE = 'text-language',
  TEXT_LOCALE = 'text-locale',
}
export { UserItemAliases };
